module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/clapper-c8bb7671b309590763d00f68477fd188.svg";